"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
export default function Aboutfirm() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
        staggerChildren: shouldReduceMotion ? 0 : 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  return <section id="aboutfirm" data-nav="light" className="bg-background text-foreground py-24 sm:py-32 lg:py-40 px-6 sm:px-8 border-b border-border/40">
      <div className="max-w-3xl mx-auto">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-80px"
      }} variants={containerVariants} className="space-y-10 text-left">
          <motion.div variants={itemVariants} className="space-y-4">
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-foreground leading-[1.15]">
              Yüksekbaş Hukuk Bürosu
            </h2>
          </motion.div>

          <motion.div variants={itemVariants} lang="tr" className="space-y-8 font-sans text-base sm:text-lg leading-relaxed text-muted-foreground text-justify hyphens-auto">
            <p>
              Yüksekbaş Hukuk ve Danışmanlık, İstanbul’da avukatlık ve hukuki danışmanlık faaliyetlerini sürdüren bir hukuk bürosudur. Büromuz; uyuşmazlıkların hukuki yönden değerlendirilmesi, dava ve icra başta olmak üzere çeşitli uyuşmazlık süreçlerinin yürütülmesi, sözleşmelerin hazırlanması ve incelenmesi ile çeşitli hukuki meselelerde görüş oluşturulması, hukuki uyuşmazlıklarda sürenin ve sürecin yönetimi gibi alanlarda faaliyet göstermektedir.
            </p>

            <p>
              Büromuzun çalışma konuları hakkında ayrıntılı bilgiye{" "}
              <Link to="/AreasOfExpertisePage" className="text-foreground font-medium underline underline-offset-4 decoration-border hover:decoration-foreground transition-colors">
                Faaliyet Alanları
              </Link>{" "}
              sayfasından; adres ve iletişim bilgilerine ise{" "}
              <Link to="/ContactPage" className="text-foreground font-medium underline underline-offset-4 decoration-border hover:decoration-foreground transition-colors">
                İletişim
              </Link>{" "}
              sayfasından ulaşabilirsiniz.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}